/**
 * OAuth Divider Component
 *
 * A visual divider with "Or continue with" text, used between
 * OAuth buttons and traditional email/password forms.
 */

interface OAuthDividerProps {
  /** Custom text to display (default: "Or continue with email") */
  text?: string;
  /** Custom class name */
  className?: string;
}

export function OAuthDivider({
  text = "Or continue with email",
  className = "",
}: OAuthDividerProps) {
  return (
    <div className={`relative my-6 ${className}`}>
      <div className="absolute inset-0 flex items-center">
        <span className="w-full border-t border-neutral-700/20" />
      </div>
      <div className="relative flex justify-center text-xs uppercase">
        <span className="bg-background px-2 text-neutral-700">{text}</span>
      </div>
    </div>
  );
}
